// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AnimatedNumber-module-container-0nnTH{display:flex;justify-content:flex-start;overflow:hidden;height:32px;height:var(--size-display-md, 32px)}[dir=rtl] .AnimatedNumber-module-container-0nnTH{flex-direction:row-reverse;justify-content:flex-end}.AnimatedNumber-module-countNumber-hXhSt{color:#fbfbfb;color:var(--des-color-fill-button-points-dropdown-active, #fbfbfb);font-size:32px;font-size:var(--size-display-md, 32px);line-height:32px;line-height:var(--size-display-md, 32px);font-weight:var(--fonts-weight-bold)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "AnimatedNumber-module-container-0nnTH",
	"countNumber": "AnimatedNumber-module-countNumber-hXhSt"
};
export default ___CSS_LOADER_EXPORT___;
